import React from 'react';
import { Modal } from '@repo/common';

const WaitlistSuccessModal = ({ isOpen, onClose }) => {
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      type='success'
      title='You’re on the waitlist'
      subText={`We’ll email you if a spot becomes available 😉
You’ll have 3 hours to pay once it’s offered`}
      links={[
        {
          text: 'View my waitlist',
          href: '/mypage?tab=Activities',
        },
      ]}
      linkclass='text-text-secondary'
      onClickLeftBtn={handleClose}
      onClickRightBtn={handleClose}
      leftButtonLabel='close'
      rightButtonLabel='Got it'
      leftHideIcon={true}
      rightHideIcon={true}
      buttonSize='xl'
    />
  );
};

export default WaitlistSuccessModal;
